import {action, computed, makeObservable, observable} from "mobx";
import SaporeForm from "../SaporeForm";

export default class FormSet extends SaporeForm {
    constructor(forms, feature, isOptional = false) {
        super(isOptional)
        this._forms = forms;
        this._feature = feature;
        this._lastId = 0
        this._formsPerId = {}
        this._forms.forEach((form) => this._updateFormsPerId(form))

        makeObservable(this, {
            _forms: observable,
            forms: computed,
            _formsPerId: observable,
            formsPerId: computed,
            _updateFormsPerId: action,
            addForm: action,
            removeForm: action,
        });
    }

    get formsPerId() {
        return this._formsPerId
    }

    get forms() {
        return this._forms;
    }

    hasForms() {
        return this._forms.length > 0;
    }

    _updateFormsPerId(form) {
        this._lastId++
        form.updateFormId(this._lastId)
        this._formsPerId[form.formId()] = form
    }

    addForm(form) {
        this._updateFormsPerId(form)
        this._forms.push(form);
        return form;
    }

    removeForm(formId) {
        const form = this._formsPerId[formId]
        this._forms.remove(form)
        delete this._formsPerId[formId];
        this._feature.deleteEntity?.(form.formEntity())
    }

    getFormById(formId) {
        return this._formsPerId[formId];
    }

    get isValid() {
        return this._forms.every(form => form.isValid);
    }

    get hasErrors() {
        return this._forms.some(form => form.hasErrors);
    }

    clear() {
        this._forms.forEach(form => form.clear());
    }

    updateValue(fieldName, value, id) {
        const form = this._formsPerId[id]
        form.updateFieldWithValue(fieldName, value)
    }

    mandatoryCompletionPercentage() {
        const formsPercentagesSum = this._forms.reduce((sum, form) => sum + form.mandatoryCompletionPercentage(), 0);
        const formsAmount = this._forms.length;
        return formsAmount > 0 ? Math.round(formsPercentagesSum / formsAmount) : 0
    }

    updateEntityIdAfterEdition(editedEntity, allIds) {
        // We must update all form data here
        const oldIds = this._forms.map(form => form.entityId())
        const newIds = allIds.filter(id => !oldIds.includes(id));
        if (newIds.length > 0) {
            const editedForm = this.getFormById(editedEntity.formId)
            editedForm.updateEntityId(newIds[0])
        }
    }
}
